export default "__VITE_ASSET__DMLCZBo4__"